/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Options_Cli_Configuration_TitleInputs */

const en_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Configuration`)
};

const fr_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Configuration de ${i?.name}`)
};

const de_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Konfiguration`)
};

const it_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Configurazione ${i?.name}`)
};

const ru_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Конфигурация ${i?.name}`)
};

const es_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Configuración de ${i?.name}`)
};

const zh_cn2_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 配置`)
};

const ja_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 構成`)
};

const hi_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} कॉन्फ़िगरेशन`)
};

const pt_pt2_options_cli_configuration_title = /** @type {(inputs: Options_Cli_Configuration_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Configuração ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{name} Configuration" |
*
* @param {Options_Cli_Configuration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_configuration_title = /** @type {((inputs: Options_Cli_Configuration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Configuration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_configuration_title(inputs)
	if (locale === "de") return de_options_cli_configuration_title(inputs)
	if (locale === "it") return it_options_cli_configuration_title(inputs)
	if (locale === "ru") return ru_options_cli_configuration_title(inputs)
	if (locale === "es") return es_options_cli_configuration_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_configuration_title(inputs)
	if (locale === "ja") return ja_options_cli_configuration_title(inputs)
	if (locale === "hi") return hi_options_cli_configuration_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_configuration_title(inputs)
	return en_options_cli_configuration_title(inputs)
});